import { useState } from "react"
import { MealEntity } from "../../Objects/MealsAndDrinks/MealEntity"
import { type ValidationError } from "../../Objects/Generics/Helps"
import { GenericFoodEntity } from "../../Objects/MealsAndDrinks/GenericFoodEntity"
import { ETypeOfCharge } from "../../Enum/ETypeOfCharge"

export const useCreateMeals = () => {
  const [typeSelected, setTypeSelectChange] = useState<ETypeOfCharge>(ETypeOfCharge.FixedValue)

  const [meals, setMeals] = useState<MealEntity | null>(null)

  const handleInitialValue = (meals: MealEntity | null | undefined) => {
    if (meals) {
      setMeals(meals)
      setTypeSelectChange(meals.typePayment)
    }
  }

  const handleSubmitForm = (genericFoodEntity: GenericFoodEntity): MealEntity | { errors: ValidationError[] } => {
    return new MealEntity({
      id: meals?.id,
      typePayment: typeSelected,
      genericFoodEntity: genericFoodEntity!,
    })
  }

  return {
    meals,
    typeSelected,
    setTypeSelectChange,
    handleSubmitForm,
    handleInitialValue,
  }
}
